import { useAuthConfig } from './useAuthConfig';

/**
 * The deployment's password rules, as GET /auth/config reports them
 * (backend internal/passwordpolicy, QA #63 / #67). Forms use them for their
 * pre-flight check and helper text so the rule they show is the one the API
 * enforces; until the request answers (or if it fails) the backend defaults
 * apply.
 */
export interface PasswordPolicy {
  minLength: number;
  maxAgeDays: number;
  /** QA #63「高強度」: ≥3 of upper / lower / digit / symbol, and not containing the account name */
  requireComplexity: boolean;
}

export const DEFAULT_PASSWORD_POLICY: PasswordPolicy = { minLength: 12, maxAgeDays: 90, requireComplexity: true };

export function usePasswordPolicy(): PasswordPolicy {
  const cfg = useAuthConfig();
  return {
    minLength: cfg.password_min_length ?? DEFAULT_PASSWORD_POLICY.minLength,
    maxAgeDays: cfg.password_max_age_days ?? DEFAULT_PASSWORD_POLICY.maxAgeDays,
    requireComplexity: cfg.password_require_complexity ?? DEFAULT_PASSWORD_POLICY.requireComplexity,
  };
}
